import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import Hero from "@/components/sections/Hero";
import ProofStrip from "@/components/sections/ProofStrip";
import Metrics from "@/components/sections/Metrics";
import Grind from "@/components/sections/Grind";
import Workforce from "@/components/sections/Workforce";
import SteerBrain from "@/components/sections/SteerBrain";
import Native from "@/components/sections/Native";
import Customers from "@/components/sections/Customers";
import CtaFinal from "@/components/sections/CtaFinal";
import { safeFetch } from "@/lib/sanity";
import { homeQuery } from "@/lib/queries";
import { homeFallback } from "@/lib/fallback";
import type { HomePage } from "@/lib/types";

export default function Home() {
  const [data, setData] = useState<HomePage>(homeFallback);

  useEffect(() => {
    let active = true;
    safeFetch<HomePage>(homeQuery).then((d) => {
      if (active && d) setData(d);
    });
    return () => {
      active = false;
    };
  }, []);

  return (
    <Layout seo={data.seo}>
      <Hero data={data.hero} />
      <ProofStrip data={data.proof} />
      <Metrics data={data.metrics} />
      <Grind data={data.grind} />
      <Workforce data={data.workforce} />
      <SteerBrain data={data.steerbrain} />
      <Native data={data.native} />
      <Customers data={data.customers} />
      <CtaFinal data={data.ctaFinal} />
    </Layout>
  );
}
